/**
 * Helpers for pre-filling the translation-key inputs on the dynamic booking
 * field/section create forms, e.g. a field labelled "Pet name" gets
 * "dynamicfield__pet-name__label" / "dynamicfield__pet-name__placeholder".
 * The keys themselves are added to every language by the serverside controllers
 * on save (UpsertTranslationKeysAsync).
 */
export function slugifyLabel(label?: string): string {
	return (label ?? '')
		.trim()
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, '-')
		.replace(/^-+|-+$/g, '');
}

export function buildTranslationKey(prefix: string, label: string | undefined, suffix: string): string {
	const slug = slugifyLabel(label);
	return slug ? `${prefix}__${slug}__${suffix}` : '';
}
